import { createContext } from 'react';

import type { DalContextValue } from './dalContextTypes';

export const DalContext = createContext<DalContextValue>(null);
